import { useState } from "react";
import gatewayApi from "./gatewayAxios";
import { useSelector } from "react-redux";

// Routed through api-auth-gateway now (see gatewayAxios.js) — endpoint stays
// relative to /api/bpay, the gateway instance's baseURL supplies the rest.

const useApi = (endpoint, method = "GET", useAuth = true) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [data, setData] = useState(null);
  const token = useSelector((state) => state.auth.employeeDetails?.token);

  const callApi = async (body = null, queryParams = null, customHeaders = {}) => {
    setLoading(true);
    setError("");
    setData(null);

    try {
      let requestUrl = endpoint;

      if (queryParams) {
        // Remove leading ? from queryParams if present
        const cleanParams = typeof queryParams === 'string' && queryParams.startsWith('?')
          ? queryParams.slice(1)
          : queryParams;

        // Check if endpoint already has a ?
        if (requestUrl.includes('?')) {
          // Endpoint already has ?, so use & for additional params
          requestUrl += `&${cleanParams}`;
        } else {
          // Endpoint doesn't have ?, so add ?
          requestUrl += `?${cleanParams}`;
        }
      }

      const isFormData = body instanceof FormData;

      const headers = {
        // Don't set Content-Type for FormData — axios/browser must derive the
        // multipart boundary itself; a manually-set value without one breaks parsing.
        ...(isFormData ? {} : { "Content-Type": "application/json" }),
        "X-Channel": "WEB",
        ...customHeaders,
      };

      if (useAuth && token) {
        headers["Authorization"] = `Bearer ${token}`;
      }


      const config = {
        method,
        url: requestUrl,
        headers,
        ...(body && ["POST", "PUT", "PATCH"].includes(method.toUpperCase()) ? { data: body } : {}),
      };
      const response = await gatewayApi(config);
      setData(response.data);
      return response.data;
    } catch (err) {
      const errorMessage = err.response?.data?.error || err.message || "Something went wrong";
      setError(errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { callApi, loading, error, data };
};

export default useApi;

